import classNames from 'classnames'

const GiftIcon = ({ className, ...props }: React.ComponentProps<'svg'>) => {
    return (
        <>
            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" className={classNames('size-4', className)} {...props}>
                <path
                    d="M12.5002 4C12.814 3.58217 13 3.0628 13 2.5C13 1.11929 11.8807 0 10.5 0C9.6822 0 8.95611 0.392673 8.5 0.99976C8.04389 0.392673 7.3178 0 6.5 0C5.11929 0 4 1.11929 4 2.5C4 3.0628 4.18597 3.58217 4.49982 4H1.75C1.05964 4 0.5 4.55964 0.5 5.25V5.75C0.5 6.44036 1.05964 7 1.75 7H7.75V4H9.25V7H15.25C15.9404 7 16.5 6.44036 16.5 5.75V5.25C16.5 4.55964 15.9404 4 15.25 4H12.5002ZM11.5 2.5C11.5 3.05228 11.0523 3.5 10.5 3.5H9.5L9.5 2.5C9.5 1.94772 9.94772 1.5 10.5 1.5C11.0523 1.5 11.5 1.94772 11.5 2.5ZM5.5 2.5C5.5 3.05228 5.94772 3.5 6.5 3.5H7.5V2.5C7.5 1.94772 7.05228 1.5 6.5 1.5C5.94772 1.5 5.5 1.94772 5.5 2.5Z"
                    fill="white"
                />
                <path d="M7.75 8.5H1.5V13.25C1.5 14.7688 2.73122 16 4.25 16H7.75V8.5Z" fill="white" />
                <path d="M9.25 16V8.5H15.5V13.25C15.5 14.7688 14.2688 16 12.75 16H9.25Z" fill="white" />
            </svg>
        </>
    )
}

export default GiftIcon
